<template>
  <base-dropdown>
    <template #title>
      <button
        class="btn btn-success dropdown-toggle btn-block"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i class="fa fa-file-export"></i> Xuất
      </button></template
    >
    <a
      :class="{ disabled: countChecked == 0 }"
      class="dropdown-item"
      href="#"
      @click="$emit('exportPdf')"
    >
      <i class="far fa-file-pdf text-warning"></i>
      Xuất PDF dòng đã chọn ({{ countChecked }})
    </a>
    <a
      :class="{ disabled: countChecked == 0 }"
      class="dropdown-item"
      href="#"
      @click="$emit('exportExcel')"
    >
      <i class="far fa-file-excel text-success"></i>
      Xuất EXCEL dòng đã chọn ({{ countChecked }})
    </a></base-dropdown
  >
</template>

<script>
export default {
  name: "export-button",
  props: {
    countChecked: {
      type: Number,
      required: true
    }
  }
};
</script>

<style></style>
